// mr-pointアプリ統合機能
// 1. カートドロワー内でのmr-point要素移動
// 2. ポイント適用/リセット時のカート表示制御
// 3. マイページでの保有ポイント表示制御

// 実行状態を管理するフラグ
let mrPointCustomerMoved = false;
let isMyPage = window.location.pathname === '/account';

document.addEventListener('DOMContentLoaded', function () {
  // 初期化時にmr-point要素を保存
  setTimeout(function() {
    saveMrPointElement();
    moveMrPointToDrawer();
  }, 100);
  
  // マイページの場合は一度だけ実行
  if (isMyPage) {
    moveMrPointCustomerToMyPage();
  }

  // カートページでのみintervalを実行
  if (!isMyPage) {
    const mrPointIntervalId = setInterval(function () {
      moveMrPointToDrawer();
    }, 200);

    setTimeout(function () {
      clearInterval(mrPointIntervalId);
    }, 30000);
  }

  const mrPointObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        setTimeout(moveMrPointToDrawer, 100);
        
        // マイページでは一度だけ実行
        if (isMyPage && !mrPointCustomerMoved) {
          setTimeout(moveMrPointCustomerToMyPage, 100);
        }
      }
    });
  });

  mrPointObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // カート更新イベントのリスナーを追加
  document.addEventListener('cart:change', function (event) {
    // カート更新前にmr-point要素を保存
    saveMrPointElement();
    
    setTimeout(moveMrPointToDrawer, 100);
    setTimeout(moveMrPointToDrawer, 500);
    setTimeout(moveMrPointToDrawer, 1000);
  });

  document.addEventListener('cart:refresh', function (event) {
    setTimeout(moveMrPointToDrawer, 100);
    setTimeout(moveMrPointToDrawer, 500);
    setTimeout(moveMrPointToDrawer, 1000);
  });

  // バリアント追加イベントのリスナーを追加
  document.addEventListener('variant:add', function (event) {
    setTimeout(moveMrPointToDrawer, 100);
    setTimeout(moveMrPointToDrawer, 500);
    setTimeout(moveMrPointToDrawer, 1000);
  });

  // 追加のイベントリスナー
  document.addEventListener('cart:updated', function (event) {
    setTimeout(moveMrPointToDrawer, 100);
  });

  // DOMの変更を監視
  document.addEventListener('DOMNodeInserted', function (event) {
    if (event.target.tagName === 'MR-POINT') {
      setTimeout(moveMrPointToDrawer, 50);
    }
  });

  // カートドロワーの表示イベントのリスナーを追加
  const cartDrawer = document.querySelector('cart-drawer');
  
  if (cartDrawer) {
    cartDrawer.addEventListener('dialog:after-show', function (event) {
      // カートドロワー表示後にmr-point要素の出現を待機
      const waitForMrPointInDrawer = setInterval(function() {
        const mrPointElements = document.querySelectorAll('mr-point');
        
        if (mrPointElements.length > 0) {
          clearInterval(waitForMrPointInDrawer);
          moveMrPointToDrawer();
        }
      }, 500);
      
      // 10秒後にチェック停止
      setTimeout(function() {
        clearInterval(waitForMrPointInDrawer);
      }, 10000);
    });

    cartDrawer.addEventListener('dialog:before-show', function (event) {
      setTimeout(moveMrPointToDrawer, 50);
    });
  }

  // mr-point要素の出現を監視（カートページのみ）
  if (!isMyPage) {
    const checkForMrPoint = setInterval(function() {
      const mrPointElements = document.querySelectorAll('mr-point');
      if (mrPointElements.length > 0) {
        clearInterval(checkForMrPoint);
        moveMrPointToDrawer();
      }
    }, 1000);
    
    // 30秒後にチェックを停止
    setTimeout(function() {
      clearInterval(checkForMrPoint);
    }, 30000);
  }
});

function moveMrPointToDrawer() {
  const mrPointElements = document.querySelectorAll('mr-point');
  const drawerMrPoint = document.querySelector('.drawer__mrpoint');

  if (mrPointElements.length > 0 && drawerMrPoint) {
    mrPointElements.forEach(function (mrPoint) {
      if (!drawerMrPoint.contains(mrPoint)) {
        try {
          drawerMrPoint.appendChild(mrPoint);
        } catch (error) {
          // エラー時は何もしない
        }
      }
    });
  } else {
    if (mrPointElements.length === 0) {
      // mr-point要素が消えた場合の復元処理
      restoreMrPointElement();
    }
  }
}

// mr-point要素を保存・復元する機能
let savedMrPointHTML = '';

function saveMrPointElement() {
  const mrPointElements = document.querySelectorAll('mr-point');
  if (mrPointElements.length > 0) {
    savedMrPointHTML = mrPointElements[0].outerHTML;
  }
}

function restoreMrPointElement() {
  if (savedMrPointHTML && !document.querySelector('mr-point')) {
    const drawerMrPoint = document.querySelector('.drawer__mrpoint');
    if (drawerMrPoint) {
      drawerMrPoint.innerHTML = savedMrPointHTML;
    }
  }
}

function moveMrPointCustomerToMyPage() {
  // マイページでない場合は実行しない
  if (!isMyPage) return;
  
  // 既に移動済みの場合は実行しない
  if (mrPointCustomerMoved) return;
  
  const mrPointCustomerElements = document.querySelectorAll('mr-point-customer');
  const targetContainer = document.querySelector('.section-header.text-start .prose');

  if (mrPointCustomerElements.length > 0 && targetContainer) {
    const h1Element = targetContainer.querySelector('h1.h3');
    const pElement = targetContainer.querySelector('p');

    if (h1Element && pElement) {
      mrPointCustomerElements.forEach(function (mrPointCustomer) {
        if (!targetContainer.contains(mrPointCustomer) || 
            mrPointCustomer.nextElementSibling !== pElement) {
          h1Element.insertAdjacentElement('afterend', mrPointCustomer);
          // 移動完了フラグを設定
          mrPointCustomerMoved = true;
        }
      });
    }
  }
}

window.addEventListener('load', function () {
  setTimeout(function() {
    const elements = document.querySelectorAll('mr-point');
    if (elements.length > 0) {
      moveMrPointToDrawer();
    }
  }, 1000);
  
  setTimeout(function() {
    const elements = document.querySelectorAll('mr-point');
    if (elements.length > 0) {
      moveMrPointToDrawer();
    }
  }, 3000);
  
  // マイページでのみ実行
  if (isMyPage) {
    setTimeout(moveMrPointCustomerToMyPage, 1000);
    setTimeout(moveMrPointCustomerToMyPage, 2000);
    setTimeout(moveMrPointCustomerToMyPage, 3000);
  }
});

// カート更新処理
function updateCartAfterPointReset() {
  fetch(Shopify.routes.root + 'cart.js')
    .then((response) => response.json())
    .then((cart) => {
      updateCartDrawerDisplay(cart);

      if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
        window.CartDrawer.refresh();
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));

      if (window.Shopify && window.Shopify.designMode !== true) {
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart: cart },
          })
        );
      }
    })
    .catch((error) => {
      console.error('カート情報の取得に失敗しました:', error);
    });
}

// カートドロワー表示の更新
function updateCartDrawerDisplay(cart) {
  // 現在のテーマ構造に合わせたセレクターで合計金額を更新
  const totalElements = document.querySelectorAll(
    '.cart-drawer__button-price .glc-money'
  );

  totalElements.forEach(function (element) {
    if (element && cart.total_price !== undefined) {
      const formattedPrice = (cart.total_price / 100).toLocaleString('ja-JP');
      element.textContent = '¥' + formattedPrice;
    }
  });

  updateDiscountDisplay(cart);
}

// 割引表示の更新
function updateDiscountDisplay(cart) {
  // 割引表示エリアを取得（Liquidテンプレートで既に表示されている割引コードの後ろ）
  const cartDrawerFooter = document.querySelector('.cart-drawer__footer');
  
  if (!cartDrawerFooter) {
    return;
  }

  // 既存のポイント割引表示を削除（data-point-discount属性を持つ要素）
  const existingPointDiscounts = cartDrawerFooter.querySelectorAll('[data-point-discount="true"]');
  existingPointDiscounts.forEach(element => element.remove());

  const originalTotal = cart.original_total_price || cart.items_subtotal_price;
  const currentTotal = cart.total_price;
  const totalDiscountAmount = originalTotal - currentTotal;
  
  // ポイント割引がある場合の表示（割引コードとの差額）
  if (totalDiscountAmount > 0) {
    // 割引コードとポイント割引を分類
    let codeDiscountAmount = 0;
    let pointDiscountAmount = 0;
    
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
      cart.cart_level_discount_applications.forEach((discount) => {
        // ポイント割引の識別：タイトルが「PT」で終わる場合はポイント割引
        if (discount.title && discount.title.endsWith('PT')) {
          pointDiscountAmount += discount.total_allocated_amount;
        } else {
          codeDiscountAmount += discount.total_allocated_amount;
        }
      });
    }
    
    if (pointDiscountAmount > 0) {
      // ポイント割引表示用のコンテナを作成
      const pointDiscountContainer = document.createElement('div');
      pointDiscountContainer.className = 'h-stack justify-start gap-4';
      pointDiscountContainer.setAttribute('data-point-discount', 'true');
      
      const discountBadge = document.createElement('span');
      discountBadge.className = 'discount-badge text-xs';
      discountBadge.innerHTML = `
        <svg aria-hidden="true" focusable="false" fill="none" width="12" class="icon icon-discount" viewBox="0 0 24 24">
          <path d="M22.707 12.293l-11-11A1.002 1.002 0 0 0 11 1H2a1 1 0 0 0-1 1v9c0 .265.105.52.293.707l11 11a.997.997 0 0 0 1.414 0l9-9a.999.999 0 0 0 0-1.414zM7 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 7 9zm6 8.414L8.586 13 10 11.586 14.414 16 13 17.414zm3-3L11.586 10 13 8.586 17.414 13 16 14.414z" fill="currentColor"></path>
        </svg>ポイント利用
      `;
      
      const discountAmountSpan = document.createElement('span');
      discountAmountSpan.className = 'text-subdued';
      discountAmountSpan.innerHTML = `-<span class="glc-money" translate="no">¥${(pointDiscountAmount / 100).toLocaleString('ja-JP')}</span>`;
      
      pointDiscountContainer.appendChild(discountBadge);
      pointDiscountContainer.appendChild(discountAmountSpan);
      
      // ボタングループの前に挿入
      const buttonGroup = cartDrawerFooter.querySelector('.button-group');
      
      if (buttonGroup) {
        cartDrawerFooter.insertBefore(pointDiscountContainer, buttonGroup);
      } else {
        cartDrawerFooter.appendChild(pointDiscountContainer);
      }
    }
  }
}

// ポイントアプリのイベント監視
function setupPointEventHandler() {
  document.addEventListener('click', function (event) {
    const target = event.target;

    if (target.closest('.mrpoint-embed__reset-button')) {
      setTimeout(updateCartForReset, 1000);
    }

    if (target.closest('.mrpoint-embed__use-button.js-use-button')) {
      setTimeout(updateCartDisplay, 2000);
    }
  });

  document.addEventListener('mrpoint:reset', function () {
    setTimeout(updateCartForReset, 500);
  });

  document.addEventListener('mrpoint:applied', function () {
    setTimeout(updateCartDisplay, 1500);
  });

  function updateCartDisplay() {
    // 即座にカート情報を取得して表示を更新
    fetch(Shopify.routes.root + 'cart.js', {
      cache: 'no-cache'
    })
      .then((response) => {
        return response.json();
      })
      .then((cart) => {
        updateCartDrawerDisplay(cart);
      })
      .catch((error) => {
      });
  }

  function updateCartForReset() {
    // ポイントリセット時はポイント割引表示を即座にクリア
    const existingPointDiscounts = document.querySelectorAll('[data-point-discount="true"]');
    existingPointDiscounts.forEach(element => element.remove());

    // サーバー側のポイントリセット処理完了を待つために少し遅延
    setTimeout(() => {
      fetch(Shopify.routes.root + 'cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const originalPrice = cart.original_total_price || cart.items_subtotal_price;
          const totalElements = document.querySelectorAll(
            '.cart-drawer__button-price .glc-money'
          );

          totalElements.forEach(function (element) {
            if (element && originalPrice) {
              const formattedPrice = (originalPrice / 100).toLocaleString('ja-JP');
              element.textContent = '¥' + formattedPrice;
            }
          });
        })
        .catch(() => {});
    }, 500); // 500ms遅延してサーバー処理完了を待つ
  }
}

document.addEventListener('DOMContentLoaded', function () {
  setupPointEventHandler();
});

window.addEventListener('load', function () {
  setTimeout(setupPointEventHandler, 1000);
}); 